export class Fund {
  id: number = null;
  sourceId: string = null;
  name: string = null;
  document: string = null;
  manager: string = null;
  cetipAccount: string = null;
  selicAccount: string = null;
  b3Account: string = null;
  class: string = null;
  accountManagerId: number = null;
  accountManagerName: string = null;
  isManualSettlementDate: boolean = null;
  disabled = false;
}
